import { ConditionalRuleMode } from "../../Models/Conditional";
import ConditionalRules from "./ConditionRules";

export default ConditionalConfig;

const ConditionalConfigModeRegistry = {
  [ConditionalRuleMode.RULES]: ConditionalRules,
};

function ConditionalConfig(props) {
  const { node } = props;

  const ConditionalConfigMode = ConditionalConfigModeRegistry[node.data.mode];

  return <ConditionalConfigMode {...props} />;
}
